import ChangeStore from "../store";
import ChangeUtils from "sh-application/utility/ChangeUtils";
import { action } from "satcheljs/lib/legacy";
import { FlightKeys, IChangeEntity } from "sh-models";
import { ECSConfigKey, ECSConfigService, FlightSettingsService } from "sh-services";
import { lastUndoableChanges } from "../computed/lastUndoableChanges";
import { revertChanges } from "./revertChanges";
import { trackChanges } from "./trackChanges";

/**
 * Perform an undo if there is a change on the stack to undo
 */
export let performUndo = action("performUndo")(
    function performUndo() {
        return new Promise<Array<IChangeEntity>>((resolve, reject) => {
            // check for undoable changes
            const hasUndoableChanges: boolean = !!lastUndoableChanges.get();
            // DnD undo is enabled independently via EnableShiftDragAndDrop so that it can ship
            // with the DnD feature flag without requiring the generic EnableShiftUndoWeb flight.
            const pendingChanges = hasUndoableChanges ? lastUndoableChanges.get() : null;
            const isDndUndoEnabled: boolean = !!pendingChanges
                && pendingChanges.length > 0
                && pendingChanges.every(c => ChangeUtils.isDragAndDrop(c))
                && ECSConfigService.isECSFeatureEnabled(ECSConfigKey.EnableShiftDragAndDrop);
            if (hasUndoableChanges && (FlightSettingsService.isFlightEnabled(FlightKeys.EnableShiftUndoWeb) || isDndUndoEnabled)) {
                // remove the last change from the undo stack and revert it
                return revertChanges(ChangeStore().undoStack.pop(), true /* fromUndo */, false /* fromRedo */)
                    .then((changes: Array<IChangeEntity>) => {
                        // track this change, it will go onto the redo stack so that it can be redid
                        trackChanges(changes, true /* fromUndo */);
                        resolve(changes);
                    }).catch(reject);
            } else {
                // resolve with empty array. Nothing was undid
                resolve([]);
            }
        });
    });
